import EInvoicingConfiguration from "./config.type";
import { BrowserCacheLocation } from "@azure/msal-browser";

export const Configuration: EInvoicingConfiguration = {
    msalConfig: {
        auth: {
            clientId: "a0ec893b-d6e4-4cae-b442-a50f0e49b897",
            authority: "https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
            redirectUri: "https://dashboard.agc.modern-einvoicing.cp.microsoft-int.com", //http://localhost:3000 
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage, // localStorage persists across redirects through CDN/Front Door
        }
    },
    
    // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
    msalTokenRequest: {
        scopes: []
    },

    eventServiceUrl: "https://event.agc.modern-einvoicing.cp.microsoft-int.com",

    featureFlags: {
        manualInvoices: false
    }
}
